import { Injectable, Injector } from '@angular/core';
import { SortOption } from '@core';
import { Observable } from 'rxjs';
import { DocListBaseService } from 'src/app/shared-feature/services/_base/doc-list-base.service';

@Injectable()
export class ArdnListService extends DocListBaseService {
  url = 'api/ardns/list';
  expandProperties =
    'Customer($select=Code),Currency($select=Code),Agent($select=Code)';
  override searchColumns: string[] = [
    'DocCode',
    'Description',
    'CustomerName',
    'Customer/Code',
    'CustomerName',
    'Agent/Code'
  ];

  sortOptions: SortOption[] = [
    { title: 'Date', sort: 'docDate' },
    { title: 'Doc #', sort: 'docCode' },
    { title: 'Customer #', sort: 'Customer/Code' },
    { title: 'Customer Name', sort: 'CustomerName' },
    { title: 'Agent #', sort: 'Agent/Code' }
  ];

  override onAction(action: string, data: any): Promise<boolean> {
    if (action === 'delete') {
      return this.confirmClearKnockoffIfAny(data.map((x: any) => x.id));
    }
    if (action === 'matchToAROR') {
      return this.confirmValidToKnockoff(data.map((x: any) => x.id));
    }
    return super.onAction(action, data);
  }

  confirmClearKnockoffIfAny(ids: any[]): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http
        .post('api/ARDNs/IsBatchKnockedoff', { ids: ids }, { _silent: true })
        .subscribe(res => {
          if (res === true) {
            const modalRef = this.modalService.confirm({
              nzTitle: 'Delete Record(s)?',
              nzContent:
                '<b>Customer debit note(s) is already knocked-off. Matched data will be cleared.</b>',
              nzOkText: 'Proceed',
              nzOkType: 'primary',
              nzOnOk: () => {
                resolve(true);
                modalRef.destroy();
              },
              nzCancelText: 'Cancel',
              nzOnCancel: () => {
                reject();
                modalRef.destroy();
              }
            });
          } else {
            resolve(true);
          }
        });
    });
  }

  confirmValidToKnockoff(ids: any[]): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http
        .post('api/ardns/IsValidKnockedoff', { ids: ids }, { _silent: true })
        .subscribe(res => {
          if(res > 0) {
            this.match(ids, res);
            resolve(true);
          }
          else {
            if(res === -1){
              this.msg.error('<b>Customer Debit Note(s) is already knocked-off.')
            }
            if(res === -2){
              this.msg.error('<b>Customer Debit Note(s) that have been selected have different customer IDs.')
            }
            reject();
          }
        });
    });
  }

  match(row: any[], customerId: any){
    this.router.navigate(['/ar/or/detail/0'], { queryParams: { customerId: customerId, docType: 'DN', toKnockoffBatch: row } });
  }

  batchDelete(ids: any[]): Observable<any> {
    return this.http.delete('api/ardns', null, { body: { ids: ids } });
  }
  constructor(injector: Injector) {
    super(injector);
  }
}
